import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterCompanyContact'
})

export class FilterPipeContactCompany implements PipeTransform {
  transform(items: any[], searchText: string): any[] {
    if (!items) { return []; }
    if (!searchText) { return items; }
    searchText = searchText.toLowerCase();
    return items.filter(it => {
      return it['givenName'].toLowerCase().includes(searchText) || it['familyName'].toLowerCase().includes(searchText);
    });
  }
}
